import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { SLOT_FIELDS } from '@ubeya/shared/constants';
import ReviewOnEmployeeRenderer from 'timeSheet/components/CellRenderers/ReviewOnEmployeeRenderer';

const useReviewOnEmployeeWithExternalColumn = ({ onUpdate, onExternalUpdate, readOnly = false }) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return ReviewOnEmployeeRenderer({
        rowData: params.data,
        columnData: {
          onUpdate,
          onExternalUpdate,
          key: SLOT_FIELDS.reviewOnEmployee,
          enablePreviewModal: true,
          showEditIcon: true,
          isSingleRow: true,
          readOnly
        }
      });
    },
    [onUpdate, onExternalUpdate, readOnly]
  );

  return useMemo(
    () => ({
      field: 'reviewOnEmployee',
      headerName: t('reviewOnEmployee'),
      width: 180,
      initialHide: true,
      sortable: false,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useReviewOnEmployeeWithExternalColumn;
